import { useCallback } from 'react';
import { FormRenderProps } from 'react-final-form';
import { Divider } from '@mui/material';

import { Button, Card, CardActions, CardContent } from '@occc/ui-design-system';
import { SubBrand, TriggeredMessageViewFragment } from '@occc/graphql';
import {
  EngagementChannelConfigForm,
  EngagementChannelConfigFormValues,
  FormContainer,
} from '@occc/ui-notifications';

import { MessageEditForm } from './message-edit-form';

import {
  TriggeredMessageEditFormValues,
  useEngagementChannelConfigForm,
} from '../../hooks/use-engagement-channel-config-form.hook';

type MessageEditDataProps = {
  message: TriggeredMessageViewFragment;
  subBrand?: SubBrand;
};

export const MessageEditData = (props: MessageEditDataProps) => {
  const { message, subBrand } = props;

  const { initialValues, isReadOnly, isBusy, onSubmit, onCancel, id } =
    useEngagementChannelConfigForm(message, subBrand);

  const MessageEditFormRenderer: FormRenderProps<EngagementChannelConfigFormValues>['render'] =
    useCallback(
      (formRenderProps: FormRenderProps<EngagementChannelConfigFormValues>) => {
        const { values, handleSubmit, invalid, dirty } = formRenderProps;
        const formValues = values as TriggeredMessageEditFormValues;

        const isSubmitDisabled = isReadOnly || isBusy || invalid || !dirty;

        return (
          <Card>
            <CardContent sx={{ padding: 0 }}>
              <FormContainer isReadOnly={isReadOnly} isBusy={isBusy}>
                <MessageEditForm
                  id={id}
                  smsConfig={formValues.smsConfig}
                  pushNotificationConfig={formValues.pushNotificationConfig}
                  onSubmit={handleSubmit}
                />
              </FormContainer>
            </CardContent>
            <Divider />
            <CardActions>
              <Button onClick={onCancel}>Cancel</Button>
              <Button
                form={id}
                color='primary'
                variant='contained'
                type='submit'
                disabled={isSubmitDisabled}
              >
                Save
              </Button>
            </CardActions>
          </Card>
        );
      },
      [id, isBusy, isReadOnly, onCancel],
    );

  return (
    <EngagementChannelConfigForm
      initialValues={initialValues}
      onSubmit={onSubmit}
      renderer={MessageEditFormRenderer}
    />
  );
};
